import React, {Component} from "react"
import PropTypes from "prop-types"
import ClassNames from "classnames"
import {_countTeamTotalLogin} from "../../../../services/apis/AdminUserServices";
import {Link} from "react-router-dom";

class TeamItem extends Component {
    state = {
        totalLogin: 0
    }

    componentDidMount() {
        this._fetchTotalLogin()
    }

    _fetchTotalLogin = async () => {
        const {_id} = this.props.data

        const {success, data} = await _countTeamTotalLogin(_id)

        if (success) {
            this.setState({totalLogin: data})
        }
    }

    render() {
        const {data, order} = this.props
        const {totalLogin} = this.state

        const {_id, owner, members, note, status} = data

        return (
            <tr className={ClassNames("Team", status)} id={`Team-${_id}`} key={_id}>
                <td className="order"><Link to={`/a/teams/${_id}`}>{order}</Link></td>
                <td className="owner">
                    <Link to={`/a/users/${owner._id}`}>{owner.profile.name}</Link>
                    <Link to={`/a/switch-user/${owner._id}`}>
                        <span className="Switch">
                            <i className="fas fa-exchange-alt"/>
                        </span>
                    </Link>
                </td>
                <td className="members">{members.length}</td>
                <td className="membership">{owner.membership.plan.title}</td>
                <td className="total-login">{totalLogin}</td>
                <td className="note">{note}</td>
            </tr>
        )
    }
}

TeamItem.propTypes = {
    order: PropTypes.number.isRequired,
    data: PropTypes.object.isRequired
}

export default TeamItem


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/teams/TeamItem.js